import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store/'
import ElementUI from 'element-ui'
// import 'element-ui/lib/theme-default/index.css'
import '@/theme/index.css'
import App from './App'
import routes from '@/router'
import '@/common/stylus/index.styl'
import { loadFromLocal } from '@/common/js/store'
import { getCookie } from '@/common/js/cookies'

Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.config.productionTip = false
Vue.prototype.apiUrl = '/_data'
Vue.prototype.cap = '/_data/user/captcha?'
Vue.prototype.env_config = window.env_config

const router = new VueRouter({
  mode: 'history',
  routes
})

window.Router = router

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.requireAuth) {
    if (loadFromLocal('token') && getCookie('isLogined')) {
      next()
    } else {
      Vue.prototype.$alert('请先登录', '温馨提示', {
        confirmButtonText: '确定',
        callback: action => {
          next({
            path: '/'
          })
        }
      })
    }
  } else {
    next()
  }
})
try {
  document.body.removeChild(document.getElementById('app-loader'))
} catch (e) {}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js